import {
  Directive,
  ElementRef,
  HostListener,
  Output,
  EventEmitter,
  OnDestroy,
  AfterViewInit,
  NgZone,
} from '@angular/core';

@Directive({
    selector: '[appTextOverflow]',
    standalone: false
})
export class TextOverflowDirective implements AfterViewInit, OnDestroy {
  @Output() overflowed = new EventEmitter<boolean>();

  constructor(
    private el: ElementRef,
    private zone: NgZone
  ) {}

  @HostListener('window:resize')
  checkOverflow() {
    const element = this.el.nativeElement;
    const isOverflowing = element.scrollWidth - 0.01 > element.clientWidth;
    this.overflowed.emit(isOverflowing);
  }

  private resizeObserver?: ResizeObserver;

  ngAfterViewInit() {
    // Initial check after microtask to ensure layout is settled
    Promise.resolve().then(() => this.checkOverflow());

    // Observe element size changes (e.g., table column resize)
    try {
      this.resizeObserver = new ResizeObserver(() => {
        this.zone.run(() => this.checkOverflow());
      });
      this.resizeObserver.observe(this.el.nativeElement);
    } catch {
      // Fallback: if ResizeObserver is not available, rely on window resize only
    }
  }

  ngOnDestroy(): void {
    try {
      this.resizeObserver?.disconnect();
    } catch {}
  }
}
